/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelZipzone.ts                       *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/general/zipzone";

export class AutogenModelZipzone<RowType extends ModelRow> extends Endpoint<RowType, RowZipzoneFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowZipzone extends ModelRow<RowZipzoneFields> {
	constructor(values?: Partial<RowZipzoneFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowZipzoneFields {
	city: string;
	company_id: string;
	empty_distance_override: number;
	market_area_id: string;
	region: string;
	state: string;
	zipcode: string;
	zone_id: string;
}

